import React from 'react';
import { useParams } from 'react-router-dom';

export default function withRouteMatch(Component) {
  return (props) => {
    const params = useParams();
    const match = React.useMemo(() => ({ params }), [params]);
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} match={match} />;
  };
}
